import React, {useEffect, useState} from 'react'
import './styles/CodigoVerificacion.css'
import {useHistory} from 'react-router'
import ModalCodigoEnviado from '../../../components/Modals/ModalsCreacion/ModalCodigoEnviado'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../reducers'
import {bindActionCreators} from 'redux'
import {
  actionCreacionUsuario,
  actionValidatorsCreacionUsuario,
} from '../../../actions/action-creators'
import {DICCIONARIO} from '../../../constants/Diccionario'
import DesignExterno from '../../../components/DesignExterno/DesignExterno'
import {KEYS} from '../../../constants/keysStorage'

const CodigoVerificacionCC = (props: any) => {
  const history = useHistory()
  const [disable, setDisable] = useState(true)
  const [openModal, setOpenModal] = useState(false)
  const verifyCode = useSelector((state: State) => state.creacionUsuario.codeVerify);
  const verifyView = localStorage.getItem(KEYS.FLAG_VERIFY_VIEW);

  const dispatch = useDispatch()

  const actionsCreate = bindActionCreators(actionCreacionUsuario, dispatch)
  const validaciones = bindActionCreators(actionValidatorsCreacionUsuario, dispatch)

  useEffect(() => {
    const username = localStorage.getItem(KEYS.USERNAME_CLIENTE)
    let auth = localStorage.getItem(KEYS.ID_CLIENT)
    if (auth || !username) {
      login()
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (verifyCode.code && !verifyCode.error) setDisable(false)
    else setDisable(true)
  }, [verifyCode])

  const submit = async (e: any) => {
    e.preventDefault()
    if (await validaciones.validacionesCreacionUsuarioVerificarCodigoSiguiente()) return
    if (await actionsCreate.creacionUsuarioVerificarCodigoEmail()) {
      history.push('/request');
      localStorage.removeItem(KEYS.FLAG_VERIFY_VIEW);
    }
  }

  const reenviarCodigo = async () => {
    if (await actionsCreate.creacionUsuarioReenviarCodigo()) setOpenModal(true)
  }

  const backButton = () => {
    //actionsCreate.creacionUsuarioChangePage(-1);
    history.push("/create");
  }

  const login = () => {
    localStorage.removeItem(KEYS.USERNAME_CLIENTE)
    history.push('/')
  }

  return (
    <DesignExterno title={<span>Confirma tu cuenta</span>}>
      <section className='centrar-horizontal'>
        <div className='w-form form-content'>
          <form
            className='form-content'
            data-wf-page-id='64af244a307770eac998c0c4'
            data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
            onSubmit={submit}
          >
            {openModal && <ModalCodigoEnviado onClose={() => setOpenModal(false)} />}
            <div>
              {
                verifyView === "true" && <button onClick={backButton} className='back-button w-inline-block'></button>
              }
              <h3 className='h3-titles xl'>Verificación de correo electrónico</h3>
              <div>Se ha enviado un código de verificación a tu correo electrónico.</div>
            </div>
            <div className='form-separator'></div>
            <div>
              <label htmlFor='idCode' className='field-label m'>
                {DICCIONARIO.CODIGO_VERIFICACION}
              </label>
              <input
                autoComplete='off'
                type='text'
                className='m text-field w-input'
                maxLength={20}
                autoFocus
                name='code'
                data-name=''
                placeholder={DICCIONARIO.CODIGO_VERIFICACION}
                id='idCode'
                value={verifyCode.code}
                onChange={actionsCreate.creacionUsuarioFormVerifyCodeHandleChange}
                onBlur={validaciones.validacionesCreacionUsuarioVerificarCodigo}
              />
              {verifyCode.error && <p className='alert s'>{verifyCode.error}</p>}
            </div>
            <div className='div-reenviar-codigos' style={{margin: '7% 0 2%'}}>
              <div>¿No te ha llegado tu código?</div>
              <button
                type='button'
                className='m button-reenviar-codig-text2'
                onClick={reenviarCodigo}
              >
                Reenviar código
              </button>
            </div>
            <div
              className='w-layout-hflex button-actions'
              style={{width: '60%', margin: '0 auto 5%'}}
            >
              <button type='submit' className='m button w-inline-block' disabled={disable}>
                Enviar
              </button>
            </div>
          </form>
        </div>
      </section>
    </DesignExterno>
  )
}

export default CodigoVerificacionCC
